/** @format */

import axios from "axios";

// Common headers for requests
function headers(val = false) {
  const headers = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  };
  return val ? headers.headers : headers;
}
// Call GET request. Pass URL & page number
export async function GETCallHelper(url, data, page) {
  try {
    // PAGE passed - call endpoint with page number
    if (data && page) {
      const response = await axios.get(`${url}?page=${page}`, {
        params: data,
        headers: headers(true),
      });
      return response;
    } else if (data) {
      const response = await axios.get(`${url}`, {
        params: data,
        headers: headers(true),
      });
      return response;
    } else if (page) {
      const response = await axios.get(`${url}?page=${page}`, headers());
      return response;
    } else {
      const response = await axios.get(url, headers());
      return response;
    }
  } catch (e) {
    return e;
  }
}
// Send POST request. Pass, URL, DATA, Page number
export async function POSTCallHelper(url, data, page) {
  try {
    // PAGE passed - call endpoint with page number
    if (page) {
      const response = await axios.post(`${url}?page=${page}`, data, headers());
      return response;
    } else {
      const response = axios.post(url, data, headers());
      return response;
    }
  } catch (e) {
    return e;
  }
}
export async function POSTCallWithFilesHelper(url, data) {
  try {
    // Use axios.post directly for proper FormData handling
    // Don't set Content-Type - let axios/browser set it with boundary
    const response = await axios.post(url, data, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        // Explicitly unset Content-Type to let browser set multipart boundary
        "Content-Type": undefined,
      },
      // Prevent axios from transforming FormData
      transformRequest: [(data) => data],
    });
    return response;
  } catch (e) {
    return e;
  }
}
export async function PATCHCallHelper(url, data, page) {
  try {
    // PAGE passed - call endpoint with page number
    if (page) {
      const response = await axios.patch(
        `${url}?page=${page}`,
        data,
        headers()
      );
      return response;
    } else {
      const response = axios.patch(url, data, headers());
      return response;
    }
  } catch (e) {
    return e;
  }
}
export async function PUTCallHelper(url, data, page) {
  try {
    if (page) {
      const response = await axios.put(`${url}?page=${page}`, data, headers());
      return response;
    } else {
      const response = await axios.put(url, data, headers());
      return response;
    }
  } catch (e) {
    return e;
  }
}
// Send DELETE request. pass URL, DATA
export async function DELETECallHelper(url, data) {
  try {
    let response;
    if (data) response = await axios.delete(url + data, headers());
    else response = await axios.delete(url, headers());
    return response;
  } catch (e) {
    return e;
  }
}
